import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import { FaqHttpService } from '../../../services/http/faqHttp.service';
import { FaqNodeDto } from '../../../domain/faq/faqNodeDto';
import { FaqSearchParams } from '../../../domain/faq/faqNodeDto';
import {FAQ_MINIMUM_LENGTH_BEFORE_SEARCH, FAQ_SEARCH_LIMIT, FAQ_DEBOUNCE_IN_MS} from '../../../services/settings/settings.keys';

@Component({
    selector: 'faq-search',
    templateUrl: './faqSearch.component.html',
    styleUrls: ['./faqSearch.component.scss']
})
export class FaqSearchComponent {

    @Output() faqNodesChange: EventEmitter<FaqNodeDto[]> = new EventEmitter<FaqNodeDto[]>();
    @Output() searchTextChange: EventEmitter<string> = new EventEmitter<string>();
    searchText: string = '';

    constructor(private readonly faqHttpService: FaqHttpService,
        @Inject(FAQ_MINIMUM_LENGTH_BEFORE_SEARCH) private readonly minimumLengthBeforeSearch: number,
        @Inject(FAQ_SEARCH_LIMIT) private readonly faqSearchLimit: number,
        @Inject(FAQ_DEBOUNCE_IN_MS) readonly faqDebounce: number) { }

    search(searchText: string): void {
        this.searchTextChange.emit(searchText);
        if (searchText?.length >= this.minimumLengthBeforeSearch) {
            const params: FaqSearchParams = {searchText: searchText, limit: this.faqSearchLimit};
            this.faqHttpService.search(params).subscribe(faqNodes => {
                this.faqNodesChange.emit(faqNodes);
            });
        } else {
            this.faqNodesChange.emit(undefined);
        }
    }
}
